import React from 'react';

import { flagStyles } from '../settings';

const SvgGB = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1800px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGB;
